import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=09faaa92&scoped=true"
import script from "./orderDialog.vue?vue&type=script&lang=js"
export * from "./orderDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDialog.vue?vue&type=style&index=0&id=09faaa92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09faaa92",
  null
  
)

export default component.exports